import { render } from "./ExpenseList.vue?vue&type=template&id=b255ee34&scoped=true"
import script from "./ExpenseList.vue?vue&type=script&lang=js"
export * from "./ExpenseList.vue?vue&type=script&lang=js"

import "./ExpenseList.vue?vue&type=style&index=0&id=b255ee34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b255ee34"]])

export default __exports__